(() => {
    const TEST_ID = "MM7";
    const VARIANT_ID = "V2";

    function logInfo(message) {
        console.log(
        `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
        "color: white; background: rgb(0, 0, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
        message
        );
    }
    logInfo('fired');

    const selector = '.main-product-v2__options-with-form';

    const styles = `
        .main-product-v2__swither {

        }
        .custom-delivery-options {
            display: flex;
            flex-direction: column;
            gap: 20px;
        }
        .custom-delivery-option {
            display: flex;
            border-radius: 3px;
            border: 1px solid #000;
            background: #FFF;
            padding: 20px;
            justify-content: space-between;
        }
        .custom-delivery-option.is-active {
            border-radius: 3px;
            border: 1px solid #03A188;
            background: #F3FFFD;
        }
        .custom-delivery-option__title {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 18px;
            margin-bottom: 16px;
        }
        @media (max-width: 1024px) {
            .custom-delivery-option__title {
                margin-bottom: 24px;
            }
        }
       .custom-delivery-option__additional-info {
            display: flex;
            align-items: normal;
            color: #505050;
            font-size: 12px;
            font-style: normal;
            font-weight: 450;
            line-height: normal;
            gap: 5px;
            text-align: start;
        }
        .custom-delivery-option__additional-info svg {
            margin-top: 4px;
        }
        .custom-delivery-option__prices {
            display: flex;
            align-items: end;
            gap: 5px;
            margin-bottom: 4px;
        }
        .custom-delivery-option__save {
            text-align: center;
            width: 65%;
            margin-left: auto;
            padding: 4px 5px;
            font-size: 12px;
            border-radius: 29px;
            line-height: normal;
        }
        .save-pct-1 {
            background: #F4CD81;
            color: #000;
        }
        .save-pct-2 {
            color: #fff;
            background: #6676B8;
        }
        .save-pct-3 {
            color: #000;
            background: #F58E84;
        }
        .custom-delivery-option__original {
            color: #757575;
            text-align: right;
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            text-decoration-line: line-through;
        }
        .custom-delivery-option__discounted {
            font-size: 18px;
        }
        .custom-delivery-option__title .main-product-v2__selling-plan-custom-input {
            width: 15px;
            height: 15px;
            display: grid;
            place-items: center;
        }
        .custom-delivery-option.is-active .main-product-v2__selling-plan-custom-input::before {
            opacity: 1 !important;
            width: 11px;
            height: 11px;
            position: static;
            transform: none;
        }
        .custom-buy-once-btn {
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-top: 15px;
            text-decoration: underline;
            font-size: 16px;
            position: relative;
            display: inline-block;
        }
        .disc-price {
            text-decoration-line: line-through;
            text-decoration-color: #9D9D9D;
            color: #9D9D9D;
        }
        body .main-product-v2__description-under-btn {
            flex-wrap: nowrap;
            font-size: 10px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            color: #505050;
            align-items: center;
            justify-content: center;
            margin-top: 11px;
        }   
       .custom-delivery-option__title-wrapper {
            position: relative;
        }
        .custom-info-modal {
            position: absolute;
            bottom: calc(100% + 10px);
            left: 66%;
            transform: translateX(-50%);
            z-index: 9999;
            width: 290px;
            background: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.12);
            border-radius: 12px;
            padding: 10px 12px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18);
        }
        .custom-info-modal.is-hidden {
            display: none;
        }
        .custom-info-modal::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -10px;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #ffffff;
            filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.08));
        }
        .modal-line {
            display: flex;
            gap: 8px;
            font-size: 13px;
            line-height: 1.3;
            color: #222222;
            align-items: center;
            justify-content: start;
        }
        .modal-line + .modal-line {
            margin-top: 8px;
        }
        .custom-delivery-option__info-trigger {
            position: relative;
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 10px 5px 0px;
        }
        .custom-delivery-option__price-ea {
            font-size: 11px;
            font-style: italic;
            font-weight: 300;
            line-height: 1;
            margin-bottom: 6px;
            color: #505050;
            text-align: right;
        }
        .custom-delivery-options__heading {
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-bottom: -2px;
            margin-top: 0;
        }
        @media (max-width: 1024px) {
            .custom-delivery-option__title {
                gap: 5px;
                font-size: 16px;
                margin-bottom: 12px;
            }
            .custom-delivery-option {
                padding: 10px; 
            }
        }
         .main-product-v2__options {
            display: none !important;
        }
        .main-product-v2__subscriptions {
            display: none !important;
        }
        .custom-delivery-option {
            position: relative;
        }
        .custom-delivery-option.is-most-popular::before {
            content: "Most popular";
            position: absolute;
            top: -10px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 15;
            border-radius: 3px;
            background: #03A188;
            color: #ffffff;
            font-size: 12px;
            font-weight: 600;
            padding: 0 10px;
            white-space: nowrap;
            text-transform: uppercase;
            line-height: 1.6;
        }
        .custom-info-modal__content ul {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
        .custom-info-modal__content li {
            display: flex;
            gap: 8px;
            font-size: 13px;
            line-height: 1.3;
            color: #222222;
            align-items: center;
            justify-content: start;
            position: relative;
            padding-left: 16px;
            text-align: start;
        }
        .custom-info-modal__content li:has(strong) {
            color: #d06599;
        }
        .custom-info-modal__content li::before {
            content: '';
            position: absolute;
            top: 6px;
            left: 0;
            width: 9px;
            height: 7px;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='7' viewBox='0 0 9 7' fill='none'%3E%3Cpath d='M7.60102 0.223174C7.75654 0.0784464 7.9635 -0.00156492 8.17823 2.3197e-05C8.39296 0.00161132 8.59866 0.0846749 8.75192 0.231686C8.90519 0.378698 8.99403 0.578158 8.99971 0.78798C9.00539 0.997802 8.92745 1.20157 8.78234 1.3563L4.37721 6.74132C4.30146 6.82107 4.21004 6.88507 4.10841 6.92949C4.00678 6.97391 3.89703 6.99785 3.78572 6.99986C3.67441 7.00188 3.56383 6.98193 3.46059 6.94122C3.35734 6.9005 3.26356 6.83985 3.18484 6.7629L0.263544 3.90744C0.182191 3.83334 0.11694 3.74398 0.0716828 3.6447C0.0264258 3.54542 0.00209051 3.43824 0.000128864 3.32957C-0.00183278 3.22089 0.0186195 3.11295 0.0602651 3.01217C0.101911 2.91138 0.163897 2.81984 0.242525 2.74298C0.321154 2.66612 0.414814 2.60553 0.517919 2.56483C0.621023 2.52412 0.73146 2.50413 0.84264 2.50604C0.953821 2.50796 1.06347 2.53175 1.16504 2.57599C1.26661 2.62022 1.35802 2.684 1.43383 2.76352L3.7457 5.02221L7.58004 0.246916L7.60102 0.223174Z' fill='%2303A188'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-size: contain;
        }
        .custom-info-modal__content li:has(strong)::before {
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='7' viewBox='0 0 9 7' fill='none'%3E%3Cpath d='M7.60102 0.223174C7.75654 0.0784464 7.9635 -0.00156492 8.17823 2.3197e-05C8.39296 0.00161132 8.59866 0.0846749 8.75192 0.231686C8.90519 0.378698 8.99403 0.578158 8.99971 0.78798C9.00539 0.997802 8.92745 1.20157 8.78234 1.3563L4.37721 6.74132C4.30146 6.82107 4.21004 6.88507 4.10841 6.92949C4.00678 6.97391 3.89703 6.99785 3.78572 6.99986C3.67441 7.00188 3.56383 6.98193 3.46059 6.94122C3.35734 6.9005 3.26356 6.83985 3.18484 6.7629L0.263544 3.90744C0.182191 3.83334 0.11694 3.74398 0.0716828 3.6447C0.0264258 3.54542 0.00209051 3.43824 0.000128864 3.32957C-0.00183278 3.22089 0.0186195 3.11295 0.0602651 3.01217C0.101911 2.91138 0.163897 2.81984 0.242525 2.74298C0.321154 2.66612 0.414814 2.60553 0.517919 2.56483C0.621023 2.52412 0.73146 2.50413 0.84264 2.50604C0.953821 2.50796 1.06347 2.53175 1.16504 2.57599C1.26661 2.62022 1.35802 2.684 1.43383 2.76352L3.7457 5.02221L7.58004 0.246916L7.60102 0.223174Z' fill='%23d1669a'/%3E%3C/svg%3E");
        }
        .custom-delivery-options__subheading.is-hidden {
            display: none;
        }
    `;

    const insertStylesOnce = (() => {
        let stylesInserted = false;

        return () => {
            if (!stylesInserted) {
                const styleElement = document.createElement('style');
                styleElement.innerHTML = styles;
                document.head.appendChild(styleElement);
                stylesInserted = true;
            }
        };
    })();

    const getProductJson = () => {
        const jsonEl = document.querySelector('.main-product-json');
        if (!jsonEl) return null;

        try {
            return JSON.parse(jsonEl.textContent);
        } catch (e) {
            return null;
        }
    };

    const formatProductMoney = (() => {
        let formatter = null;

        return (cents) => {
            if (cents == null || cents === '') return '';

            if (!formatter) {
                const currency = window.Shopify?.currency?.active || 'USD';
                const language = window.Shopify?.locale || 'en-US';
                formatter = new Intl.NumberFormat(language, {
                    style: 'currency',
                    currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }

            return formatter.format(Number(cents) / 100).replace(/^A\$/, '$');
        };
    })();

    const enrichItemPricesFromProductJson = (items) => {
        const product = getProductJson();
        if (!product?.variants?.length) return items;

        items.forEach((item) => {
            const variant = product.variants.find((v) => String(v.id) === String(item.variantId));
            if (!variant) return;

            const sellingPlanId = item.subscribe.sellingPlanId;
            const plan = (variant.selling_plans || []).find(
                (sp) => String(sp.id) === String(sellingPlanId)
            );

            const variantPrice = Number(variant.price);
            const subPrice = plan?.price != null ? Number(plan.price) : variantPrice;
            const compareAt = Number(variant.compare_at_price);

            if (compareAt > variantPrice) {
                item.subscribe.originalPrice = formatProductMoney(compareAt);
            } else if (variantPrice > subPrice) {
                item.subscribe.originalPrice = formatProductMoney(variantPrice);
            } else {
                item.subscribe.originalPrice = item.subscribe.originalPrice || '';
            }

            item.subscribe.discountedPrice = formatProductMoney(subPrice);

            const bottleCount = Number(item.bottleCount) || 0;
            if (bottleCount > 0) {
                item.subscribe.priceEaText = `${formatProductMoney(Math.round(subPrice / bottleCount))} per bottle`;
            }

            const otpVariantId = item.otpVariantId;
            const otpVariant = otpVariantId
                ? product.variants.find((v) => String(v.id) === String(otpVariantId))
                : variant;

            if (otpVariant) {
                const otpPrice = Number(otpVariant.price);
                const otpCompareAt = Number(otpVariant.compare_at_price);

                if (otpCompareAt > otpPrice) {
                    item.otp.price = formatProductMoney(otpCompareAt);
                    item.otp.discPrice = formatProductMoney(otpPrice);
                } else {
                    item.otp.price = '';
                    item.otp.discPrice = formatProductMoney(otpPrice);
                }
            }
        });

        return items;
    };

    const updateMarkup = async (elementToUpdate) => {
        insertStylesOnce();
        logInfo(`updateMarkup: start (selector hit=${!!elementToUpdate})`);

        const switcher = document.querySelector('.main-product-v2__swither');
        if (!switcher) {
            logInfo('updateMarkup: missing .main-product-v2__swither');
            return;
        }

        if (switcher.dataset.customDeliveryMounted === '1') {
            logInfo('updateMarkup: already mounted (customDeliveryMounted=1)');
            return;
        }

        const scope = elementToUpdate || switcher;
        const fieldsets = Array.from(
            scope.querySelectorAll('.main-product-v2__selling-plans, .main-product-v2__subscriptions fieldset')
        );
        logInfo(`updateMarkup: selling plan fieldsets=${fieldsets.length}`);
        if (!fieldsets.length) {
            const attempts = Number(switcher.dataset.customDeliveryWaitAttempts || '0');
            if (attempts < 20) {
                switcher.dataset.customDeliveryWaitAttempts = String(attempts + 1);
                logInfo(`updateMarkup: no selling plan fieldsets yet, retrying (${attempts + 1}/20)`);
                setTimeout(() => updateMarkup(elementToUpdate), 250);
            } else {
                logInfo('updateMarkup: no selling plan fieldsets after retries -> abort');
            }
            return;
        }

        const itemsRaw = fieldsets
            .map((fs) => {
                const variantId = String(fs.dataset.variantId || '');
                if (!variantId) {
                    return null;
                }

                const otpVariantId = String(fs.dataset.otpVariantId || '');

                const subscribeInput = fs.querySelector(
                    '.main-product-v2__selling-plan-input[value]:not([value=""])'
                );
                const buyOnceInput = fs.querySelector('.main-product-v2__selling-plan-input[value=""]');

                if (!subscribeInput || !buyOnceInput) {
                    return null;
                }

                const descriptionEl = fs.querySelector('.main-product-v2__selling-plan-description');

                const planHeadingEl = fs.querySelector('.main-product-v2__selling-plan-heading');
                const planHeadingHtml = planHeadingEl ? planHeadingEl.outerHTML : '';

                const subscribeLabel = subscribeInput.closest('.main-product-v2__selling-plan');
                const buyOnceLabel = buyOnceInput.closest('.main-product-v2__selling-plan');

                if (!subscribeLabel || !buyOnceLabel) {
                    return null;
                }

                const saveEl = subscribeLabel.querySelector('.main-product-v2__selling-plan-save');
                const saveTextRaw = saveEl ? saveEl.textContent.trim() : '';
                const pctMatch = saveTextRaw.match(/(\d+)\s*%/);
                const savePct = pctMatch ? pctMatch[1] : '';
                const saveShortText = savePct ? `Save ${savePct}%` : '';

                const subOriginalEl = subscribeLabel.querySelector(
                    '.main-product-v2__selling-plan-original-price'
                );
                const subDiscountedEl = subscribeLabel.querySelector('.main-product-v2__selling-plan-price');

                const subOriginal = subOriginalEl ? subOriginalEl.textContent.trim() : '';
                const subDiscounted = subDiscountedEl ? subDiscountedEl.textContent.trim() : '';

                const otpPriceEl = buyOnceLabel.querySelector('.main-product-v2__selling-plan-original-price');
                const otpDiscPriceEl = buyOnceLabel.querySelector('.main-product-v2__selling-plan-price');

                const otpPrice = otpPriceEl ? otpPriceEl.textContent.trim() : '';
                const otpDiscPrice = otpDiscPriceEl ? otpDiscPriceEl.textContent.trim() : '';

                const sellingPlanId = String(subscribeInput.value || '');
                if (!sellingPlanId) {
                    return null;
                }

                const priceEaEl = subscribeLabel.querySelector('.main-product-v2__selling-plan-price-ea');
                const priceEaText = priceEaEl ? priceEaEl.textContent.trim() : '';

                return {
                    variantId,
                    otpVariantId,
                    subscribe: {
                        input: subscribeInput,
                        label: subscribeLabel,
                        sellingPlanId,
                        originalPrice: subOriginal,
                        discountedPrice: subDiscounted,
                        priceEaText
                    },
                    otp: {
                        input: buyOnceInput,
                        label: buyOnceLabel,
                        price: otpPrice,
                        discPrice: otpDiscPrice
                    },
                    saveShortText,
                    descriptionEl,
                    planHeadingHtml
                };
            })
            .filter(Boolean);

        if (!itemsRaw.length) {
            logInfo('updateMarkup: itemsRaw empty -> abort (no .main-product-v2__selling-plans rendered?)');
            return;
        }

        switcher.dataset.customDeliveryMounted = '1';
        logInfo('updateMarkup: mount flag set');

        const clickIfExists = (el) => {
            if (!el) return;
            el.click();
        };

        const getPackCountsFromDom = () => {
            const inputs = Array.from(document.querySelectorAll('input[name="options[Pack Size]"]'));
            const counts = inputs
                .map((i) => {
                    const m = String(i.value || '').match(/(\d+)/);
                    return m ? Number(m[1]) : null;
                })
                .filter((n) => Number.isFinite(n));

            const uniq = Array.from(new Set(counts));
            uniq.sort((a, b) => a - b);
            return uniq;
        };

        const packCounts = getPackCountsFromDom();
        const fallbackCounts = [15, 30, 60];
        const bottleCounts = packCounts.length ? packCounts : fallbackCounts;
        logInfo(`updateMarkup: packCounts=${JSON.stringify(packCounts)} bottleCounts=${JSON.stringify(bottleCounts)}`);

        const fetchVariantAvailability = async (variantIds) => {
            const unique = Array.from(new Set(variantIds.filter(Boolean).map(String)));

            const fetchOne = async (id) => {
                const endpoints = [
                    `/variants/${encodeURIComponent(id)}.js`,
                    `/variants/${encodeURIComponent(id)}.json`
                ];

                for (let i = 0; i < endpoints.length; i += 1) {
                    const url = endpoints[i];

                    try {
                        const res = await fetch(url, { credentials: 'same-origin' });
                        if (!res.ok) {
                            continue;
                        }

                        const data = await res.json();

                        const v = data && data.variant ? data.variant : data;
                        const available = typeof v.available === 'boolean' ? v.available : null;

                        if (available !== null) {
                            return { ok: true, id, available };
                        }
                    } catch (e) {
                        continue;
                    }
                }

                return { ok: false, id, available: null };
            };

            const results = await Promise.all(unique.map((id) => fetchOne(id)));

            const map = {};
            results.forEach((r) => {
                if (!r) return;
                map[String(r.id)] = r.available;
            });

            return map;
        };

        const idsToCheck = itemsRaw.flatMap((x) => [x.variantId, x.otpVariantId]).filter(Boolean);
        logInfo(`updateMarkup: idsToCheck=${idsToCheck.length}`);
        const availabilityById = await fetchVariantAvailability(idsToCheck);
        logInfo(`updateMarkup: availability keys=${Object.keys(availabilityById || {}).length}`);

        const isItemAvailable = (item) => {
            const subAvail = availabilityById[String(item.variantId)];
            const otpAvail = item.otpVariantId ? availabilityById[String(item.otpVariantId)] : undefined;

            const subKnown = typeof subAvail === 'boolean';
            const otpKnown = typeof otpAvail === 'boolean';

            if (!subKnown && !otpKnown) {
                return true;
            }

            if (subKnown && subAvail === true) return true;
            if (otpKnown && otpAvail === true) return true;

            return false;
        };

        const items = itemsRaw
            .map((item, index) => {
                const bottleCount = bottleCounts[index] || bottleCounts[bottleCounts.length - 1];
                return { ...item, bottleCount };
            })
            .filter((item) => isItemAvailable(item));

        if (!items.length) {
            logInfo('updateMarkup: items empty after availability filter -> abort');
            return;
        }
        enrichItemPricesFromProductJson(items);
        logInfo(`updateMarkup: items ready=${items.length}`);

        const selectPackSizeByBottleCount = (bottleCount) => {
            const inputs = Array.from(document.querySelectorAll('input[name="options[Pack Size]"]'));
            if (!inputs.length) return;

            const parseCount = (val) => {
                const m = String(val || '').match(/(\d+)/);
                return m ? Number(m[1]) : null;
            };

            const target = Number(bottleCount);
            const options = inputs
                .map((input) => ({
                    input,
                    count: parseCount(input.value),
                    checked: !!input.checked
                }))
                .filter((x) => Number.isFinite(x.count));

            if (!options.length) return;

            let picked = options.find((x) => x.count === target);

            if (!picked) {
                picked = options.reduce((best, cur) => {
                    if (!best) return cur;
                    return Math.abs(cur.count - target) < Math.abs(best.count - target) ? cur : best;
                }, null);
            }

            if (!picked || !picked.input) return;

            const label = picked.input.closest('label');
            if (label) {
                clickIfExists(label);
                return;
            }

            clickIfExists(picked.input);
        };

        const selectSubscribeForItem = (item, bottleCount) => {
            selectPackSizeByBottleCount(bottleCount);

            const subscribeInput = item.subscribe.input;
            if (!subscribeInput) return;

            const subscribeLabel =
                subscribeInput.closest('label') ||
                subscribeInput.closest('.main-product-v2__selling-plan') ||
                item.subscribe.label;

            if (subscribeLabel) {
                clickIfExists(subscribeLabel);
            } else {
                clickIfExists(subscribeInput);
            }
        };

        const selectOtpForItem = (item, bottleCount) => {
            selectPackSizeByBottleCount(bottleCount);

            const otpInput = item.otp.input;
            if (!otpInput) return;

            const otpLabel =
                otpInput.closest('label') ||
                otpInput.closest('.main-product-v2__selling-plan') ||
                item.otp.label;

            if (otpLabel) {
                clickIfExists(otpLabel);
            } else {
                clickIfExists(otpInput);
            }
        };

        const setActiveDelivery = (activeVariantId) => {
            const btns = switcher.querySelectorAll('.custom-delivery-option');
            btns.forEach((btn) => {
                btn.classList.toggle('is-active', btn.dataset.variantId === String(activeVariantId));
            });
        };

        const setBuyOnceButtonState = (btn, item, mode) => {
            if (!btn || !item) return;

            const price = item.otp.price || '';
            const discPrice = item.otp.discPrice || '';
    
            btn.dataset.variantId = item.variantId;
            btn.classList.toggle('is-active', mode === 'otp');

            if (price) {
                btn.innerHTML = `Buy it once for <span class="disc-price">${price}</span> ${discPrice}`;
            } else {
                btn.innerHTML = 'Buy it once';
            }
        };

        const getModeForItem = (item) => {
            if (item.otp.input && item.otp.input.checked) return 'otp';
            if (item.subscribe.input && item.subscribe.input.checked) return 'sub';
            return 'sub';
        };

        const closeAllModals = () => {
            document.querySelectorAll('.custom-info-modal').forEach((m) => m.classList.add('is-hidden'));
        };

        let activeVariantId =
            items.find((x) => x.subscribe.input.checked || x.otp.input.checked)?.variantId ||
            items[0].variantId;

        const wrap = document.createElement('div');
        wrap.className = 'custom-delivery-options';

        const heading = document.createElement('h2');
        heading.className = 'custom-delivery-options__heading';
        heading.textContent = 'Select your plan:';
        wrap.appendChild(heading);

        const dynamicPlanHeading = document.createElement('div');
        dynamicPlanHeading.className = 'custom-delivery-options__subheading is-hidden';
        wrap.appendChild(dynamicPlanHeading);

        const setPlanHeadingForItem = (item) => {
            if (!dynamicPlanHeading || !item) return;

            const html = String(item.planHeadingHtml || '').trim();

            if (!html) {
                dynamicPlanHeading.innerHTML = '';
                dynamicPlanHeading.classList.add('is-hidden');
                return;
            }

            dynamicPlanHeading.innerHTML = html;
            dynamicPlanHeading.classList.remove('is-hidden');
        };

        items.forEach((item, index) => {
            const saveClass = `save-pct-${index + 1}`;
            const bottleCount = item.bottleCount;
            const titleText = `${bottleCount} Bottle Delivery`;

            const descriptionHtml = item.descriptionEl ? item.descriptionEl.innerHTML : '';

            const modalText = `
                ${descriptionHtml}
            `;

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'custom-delivery-option';
            if (index === 1) {
                btn.classList.add('is-most-popular');
            }
            btn.dataset.variantId = item.variantId;
            btn.dataset.sellingPlanId = item.subscribe.sellingPlanId;
            btn.dataset.bottleCount = String(bottleCount);

            btn.innerHTML = `
                <div class="custom-delivery-option__title-wrapper">
                    <div class="custom-delivery-option__title">
                        <div class="main-product-v2__selling-plan-custom-input"></div>
                        ${titleText}
                        <button type="button" class="custom-delivery-option__info-trigger" aria-label="More info">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66402 1.05138C5.29094 1.12229 3.95728 1.69038 2.94263 2.63654C1.34945 4.1222 0.694136 6.33232 1.21919 8.44898C1.74555 10.5708 3.42925 12.2525 5.55762 12.7823C6.49876 13.0165 7.50127 13.0165 8.44241 12.7823C9.73595 12.4603 10.8729 11.7181 11.714 10.6466C12.1134 10.1378 12.4703 9.46069 12.6765 8.82037C13.01 7.7845 13.0477 6.62391 12.7823 5.55759C12.4603 4.26399 11.7182 3.12709 10.6467 2.28598C10.3517 2.05447 9.93566 1.79822 9.57292 1.62472C8.84603 1.27703 8.11463 1.09269 7.29402 1.05034C6.99603 1.03496 6.98144 1.03499 6.66402 1.05138ZM6.57411 2.56377C5.68403 2.64933 4.82726 3.00781 4.14402 3.58055C2.93009 4.59815 2.35259 6.15416 2.60474 7.72798C2.69152 8.2695 2.89212 8.8156 3.17944 9.29247C3.84937 10.4043 4.97034 11.1729 6.23702 11.3889C6.80197 11.4853 7.43704 11.4701 7.98002 11.3473C9.65367 10.9687 10.9687 9.65364 11.3473 7.97998C11.4671 7.4503 11.4847 6.81974 11.395 6.26924C11.2691 5.49583 10.9258 4.748 10.4194 4.14398C9.65751 3.23504 8.58342 2.67259 7.39902 2.56234C7.21954 2.54563 6.75443 2.54644 6.57411 2.56377ZM6.90902 4.1739C6.73171 4.19026 6.58055 4.26817 6.4477 4.41167C6.06496 4.82508 6.2644 5.50218 6.81001 5.64173C7.0819 5.71127 7.33548 5.64251 7.53202 5.44598C7.693 5.28499 7.76493 5.09739 7.75212 4.87198C7.72722 4.43375 7.36278 4.13201 6.90902 4.1739ZM6.86002 6.25988C6.64939 6.29441 6.42761 6.46543 6.32736 6.67063C6.2951 6.73664 6.26664 6.82051 6.25835 6.87398C6.23948 6.9956 6.23972 9.07342 6.25862 9.2042C6.2966 9.467 6.51553 9.72067 6.77298 9.80019C6.89643 9.83831 7.1036 9.83831 7.22705 9.80019C7.4858 9.72026 7.70028 9.47067 7.74081 9.20229C7.76065 9.07097 7.76121 7.01919 7.74146 6.88098C7.69856 6.58103 7.42688 6.30627 7.12602 6.25861C7.02117 6.24199 6.96751 6.24226 6.86002 6.25988Z" fill="#535353"/>
                            </svg>
                            <div class="custom-info-modal is-hidden">
                                <div class="custom-info-modal__content">
                                    ${modalText}
                                </div>
                                <div class="custom-info-modal__arrow"></div>
                            </div>
                        </button>
                    </div>
                    <div class="custom-delivery-option__additional-info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
                            <path d="M7.60102 0.223174C7.75654 0.0784464 7.9635 -0.00156492 8.17823 2.3197e-05C8.39296 0.00161132 8.59866 0.0846749 8.75192 0.231686C8.90519 0.378698 8.99403 0.578158 8.99971 0.78798C9.00539 0.997802 8.92745 1.20157 8.78234 1.3563L4.37721 6.74132C4.30146 6.82107 4.21004 6.88507 4.10841 6.92949C4.00678 6.97391 3.89703 6.99785 3.78572 6.99986C3.67441 7.00188 3.56383 6.98193 3.46059 6.94122C3.35734 6.9005 3.26356 6.83985 3.18484 6.7629L0.263544 3.90744C0.182191 3.83334 0.11694 3.74398 0.0716828 3.6447C0.0264258 3.54542 0.00209051 3.43824 0.000128864 3.32957C-0.00183278 3.22089 0.0186195 3.11295 0.0602651 3.01217C0.101911 2.91138 0.163897 2.81984 0.242525 2.74298C0.321154 2.66612 0.414814 2.60553 0.517919 2.56483C0.621023 2.52412 0.73146 2.50413 0.84264 2.50604C0.953821 2.50796 1.06347 2.53175 1.16504 2.57599C1.26661 2.62022 1.35802 2.684 1.43383 2.76352L3.7457 5.02221L7.58004 0.246916L7.60102 0.223174Z" fill="black"/>
                        </svg>
                        Delivered Monthly + Subscription Benefits
                    </div>
                </div>

                <div class="custom-delivery-option__prices-wrapper">
                    <div class="custom-delivery-option__prices">
                        ${item.subscribe.originalPrice ? `<s class="custom-delivery-option__original">${item.subscribe.originalPrice}</s>` : ''}
                        ${item.subscribe.discountedPrice ? `<span class="custom-delivery-option__discounted">${item.subscribe.discountedPrice}</span>` : ''}
                    </div>

                    ${item.subscribe.priceEaText
                        ? `<div class="custom-delivery-option__price-ea">${item.subscribe.priceEaText}</div>`
                        : ''
                    }

                    ${(() => {
                        if (!item.subscribe.originalPrice || !item.subscribe.discountedPrice) {
                            return '';
                        }

                        const original = parseFloat(
                            item.subscribe.originalPrice.replace(/[^0-9.]/g, '')
                        );

                        const discounted = parseFloat(
                            item.subscribe.discountedPrice.replace(/[^0-9.]/g, '')
                        );

                        if (!original || !discounted || discounted >= original) {
                            return '';
                        }

                        const percent = Math.round(((original - discounted) / original) * 100);

                        return `
                            <div class="custom-delivery-option__save ${saveClass}">
                                Save ${percent}%
                            </div>
                        `;
                    })()}
                </div>
            `;

            const infoTrigger = btn.querySelector('.custom-delivery-option__info-trigger');
            const modal = infoTrigger ? infoTrigger.querySelector('.custom-info-modal') : null;

            if (modal) {
                modal.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }

            if (infoTrigger && modal) {
                infoTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    document.querySelectorAll('.custom-info-modal').forEach((m) => {
                        if (m !== modal) {
                            m.classList.add('is-hidden');
                        }
                    });

                    modal.classList.toggle('is-hidden');
                });
            }

            btn.addEventListener('click', () => {
                closeAllModals();

                setPlanHeadingForItem(item);

                activeVariantId = item.variantId;

                selectSubscribeForItem(item, bottleCount);

                setActiveDelivery(item.variantId);

                const buyOnceBtn = document.querySelector('.custom-buy-once-btn');
                const mode = getModeForItem(item);
                setBuyOnceButtonState(buyOnceBtn, item, mode);
            });

            wrap.appendChild(btn);
        });

        switcher.appendChild(wrap);

        if (switcher.dataset.customDeliveryDocClickBound !== '1') {
            switcher.dataset.customDeliveryDocClickBound = '1';

            document.addEventListener('click', () => {
                closeAllModals();
            });
        }

        const firstBtn = wrap.querySelector('.custom-delivery-option');
        if (firstBtn) {
            firstBtn.classList.add('is-active');

            const variantId = String(firstBtn.dataset.variantId || '');
            const bottleCount = Number(firstBtn.dataset.bottleCount || '15');
            const firstItem = items.find((x) => x.variantId === variantId);

            if (firstItem) {
                setPlanHeadingForItem(firstItem);
                activeVariantId = firstItem.variantId;
                selectSubscribeForItem(firstItem, bottleCount);
            }
        }

        const getAddToCartForm = () => {
            return (
                document.querySelector('form[action="/cart/add"]') ||
                document.querySelector('form[action*="/cart/add"]') ||
                switcher.closest('form')
            );
        };

        const form = getAddToCartForm();
        if (form) {
            let buyOnceBtn = document.querySelector('.custom-buy-once-btn');

            if (!buyOnceBtn) {
                buyOnceBtn = document.createElement('button');
                buyOnceBtn.type = 'button';
                buyOnceBtn.className = 'custom-buy-once-btn';

                const targetEl = document.querySelector('.main-product-v2__description-under-btn');

                if (targetEl) {
                    targetEl.insertAdjacentElement('beforebegin', buyOnceBtn);
                }
            }

            const triggerAddToCart = () => {
                const atcBtn = document.querySelector('.main-product-v2__atc-button[type="submit"]');
                if (!atcBtn) return;

                atcBtn.click();
            };

            buyOnceBtn.addEventListener('click', () => {
                closeAllModals();

                const item = items.find((x) => x.variantId === String(activeVariantId));
                if (!item) return;

                const activeBtn = wrap.querySelector(
                    `.custom-delivery-option[data-variant-id="${CSS.escape(String(activeVariantId))}"]`
                );
                const bottleCount = activeBtn ? Number(activeBtn.dataset.bottleCount || '15') : 15;

                selectOtpForItem(item, bottleCount);

                setActiveDelivery(item.variantId);
                setBuyOnceButtonState(buyOnceBtn, item, 'otp');

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        triggerAddToCart();
                    });
                });
            });

            const currentItem = items.find((x) => x.variantId === String(activeVariantId)) || items[0];
            const mode = getModeForItem(currentItem);
            setBuyOnceButtonState(buyOnceBtn, currentItem, mode);
        }

        const textUnderCta = document.querySelector('.main-product-v2__description-under-btn');
        if (textUnderCta) {
            textUnderCta.innerHTML = `
                <span>
                    Free 3-5 Day Shipping
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                    <circle cx="2.5" cy="2.5" r="2.5" fill="#03A188"/>
                </svg>
                <span>
                    100-day money-back guarantee
                </span>
            `;
        }
    };

    const observePageURL = () => {
        let pageURL = location.href;
        const observer = new MutationObserver(() => {
            if (pageURL !== location.href) {
                pageURL = location.href;
                logInfo(`url changed: ${pageURL}`);
                waitForElement(selector).then((existingElement) => {
                    if (existingElement) {
                        logInfo('observePageURL: selector found, rerender');
                        updateMarkup(existingElement);
                    }
                });
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    const waitForElement = (selector) => {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                logInfo(`waitForElement: immediate hit for ${selector}`);
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                observer.disconnect();
                logInfo(`waitForElement: hit after mutation for ${selector}`);
                resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    };

    const initializeTemplate = () => {
        logInfo(`initializeTemplate: waiting for ${selector}`);
        waitForElement(selector).then((existingElement) => {
            if (existingElement) {
                logInfo('initializeTemplate: selector found, first render');
                updateMarkup(existingElement);
            }
        });
        observePageURL();
    };

    initializeTemplate();
})();
